document.addEventListener("DOMContentLoaded", initialiseDiscountField);
document.addEventListener("refreshPromoField", initialiseDiscountField);

document.addEventListener('on:line-item:change', () => {
  initialiseDiscountField();
});

document.addEventListener('on:cart:add', () => {
  initialiseDiscountField();
});

function initialiseDiscountField(apply, button) { 
  console.log("INIT DISCOUNT FIELD");

  let clearBtn = document.querySelector("#clear-discount-btn");
  let applyBtn = document.querySelector("#apply-discount-btn");
  let discountCodeError = document.querySelector("#discount-code-error");
  let discountCodeWrapper = document.querySelector("#applied-discount-code .applied-discount-code-wrapper");
  let discountCodeSuccessMessage = document.querySelector(".discount-code-success");
  let discountCodeErrorContainer = document.querySelector('.discount-code-error-container');
  let discountCodeSavings = document.querySelector('.discount-code-savings');
  let discountCodeIndicator = document.querySelector(".discount-code-indicator");
  let discountCodeValue = document.querySelector("#applied-discount-code .applied-discount-code-value");
  let discountCodeInput = document.querySelector("#discount-code-input");
  let automaticDiscountCode = document.querySelector('#auto-discount-code');

  // Ensure discount field is always visible
  if (discountCodeWrapper) discountCodeWrapper.style.display = "block";

  // Apply automatic discount if available
  if (automaticDiscountCode && !apply) {
    let title = automaticDiscountCode.getAttribute('data-title');
    if(title) applyDiscount(title);
  } else if (localStorage.discountCode && !apply) {
    applyDiscount(JSON.parse(localStorage.discountCode).code);
  }

  // Clear discount button
  if(clearBtn) {
    clearBtn.addEventListener("click", function(e){
      e.preventDefault();
      clearDiscount();
    });
  }

  function clearDiscount() {
    discountCodeValue.innerHTML = "";
    discountCodeError.innerHTML = "";
    clearLocalStorage();
    fetch("/checkout?discount=%20");
  }

  function clearLocalStorage() {
    if(discountCodeWrapper) discountCodeWrapper.style.display = "none";
    localStorage.removeItem("discountCode");
  }

  function applyDiscount(code) {
    if(!code) return;

    if(applyBtn){
      applyBtn.innerHTML = "Appliquer <div class="loader"></div>";
      applyBtn.style.pointerEvents = "none";
    }

    fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: code })
    })
    .then(res => res.json())
    .then(cart => {
      let applicableDiscounts = cart.discount_codes.filter(d => d.applicable === true);
      if(cart && applicableDiscounts.length > 0){
        fetch('/cart?view=discount')
        .then(res => res.text())
        .then(data => {
          let dataObject = JSON.parse(data);
          let appliedPromo = dataObject.discounts.find(d => d.title.toUpperCase() === code.toUpperCase());

          if(discountCodeWrapper) discountCodeWrapper.style.display = "block";
          if(discountCodeError) discountCodeError.innerHTML = "";
          if(discountCodeValue) discountCodeValue.innerHTML = `${appliedPromo.title} (${appliedPromo.amount} ${Shopify.currency.active})`;
          if(discountCodeIndicator) discountCodeIndicator.innerHTML = appliedPromo.title;
          if(discountCodeSavings) discountCodeSavings.innerHTML = appliedPromo.amount; 
          if(discountCodeErrorContainer) discountCodeErrorContainer.style.display = 'none';
          if(discountCodeSuccessMessage) discountCodeSuccessMessage.style.display = 'block';

          localStorage.setItem("discountCode", JSON.stringify({ code: code.trim() }));
          let totalCartSelector = document.querySelector('.cart-subtotal__amount span');
          if(totalCartSelector) totalCartSelector.innerHTML = dataObject.total_price_with_currency;
          let comparePriceCartSelector = document.querySelector('.cart-subtotal__amount s');
          if(comparePriceCartSelector) comparePriceCartSelector.innerHTML = dataObject.total_full_price;
        });
      } else {
        if(discountCodeValue) discountCodeValue.innerHTML = "";
        clearLocalStorage();
        fetch('/cart?view=discount')
        .then(res => res.text())
        .then(data => {
          let dataObject = JSON.parse(data);
          let totalCartSelector = document.querySelector('.cart-subtotal__amount span');
          let comparePriceCartSelector = document.querySelector('.cart-subtotal__amount s');
          if(comparePriceCartSelector) comparePriceCartSelector.innerHTML = "";
          if(totalCartSelector) totalCartSelector.innerHTML = dataObject.total_price_with_currency;
        });
        if(discountCodeError){
          discountCodeError.innerText = `Le code promo ${discountCodeInput.value} n'a pas pu être appliqué`;
          discountCodeErrorContainer.style.display = 'block';
        }
      }
    })
    .finally(() => {
      if(applyBtn){
        applyBtn.innerHTML = "Appliquer";
        applyBtn.style.pointerEvents = "all";
      }
    });
  }

  // Apply discount on click if the button was pressed
  if(apply === true && button?.id === "apply-discount-btn") {
    let discountCodeInputText = button.closest('.discount-code-input-container').querySelector('#discount-code-input').value;
    applyDiscount(discountCodeInputText);
  }
}

// Observer for automatic discount changes
function initialiseObserver() {
  const targetNode = document.getElementById("auto-discount-code");
  if(!targetNode) return;

  const config = { attributes: true };
  const callback = (mutationList) => {
    for (const mutation of mutationList) {
      if (mutation.type === "attributes" && mutation.attributeName === "data-title") {
        let code = targetNode.getAttribute('data-title');
        if(code) initialiseDiscountField(false, null);
      }
    }
  };

  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
}

// Initialize observer on page load
document.addEventListener("DOMContentLoaded", initialiseObserver);
